import { useLiveQuery } from 'dexie-react-hooks';
import { inspectionDB } from '../data/database.structure';
import { InspectionModel } from '../data/types';

/**
 * The stored Inspection, kept current by Dexie: `undefined` while it loads, `null` when
 * nothing is stored. For reading its delivery state, which the cached Inspection
 * (`useInspection`) misses when a submit or a send changes it.
 */
export function useStoredInspection(
  externalId: string,
): InspectionModel | null | undefined {
  return useLiveQuery(
    async () => (await inspectionDB.inspections.get(externalId)) ?? null,
    [externalId],
  );
}
